module.exports = __webpack_public_path__ + "static/media/hearthand.ada44ad5.svg";